<template lang="html">
    <div>
        <template>
            <p>Êtes-vous sûr de vouloir supprimer ce produit ?</p>
			<p><strong>{{ $store.state.single.data.label }}</strong></p>
        </template>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                title:          'Supression d\'un produit',
                icon:           'delete',
                warning:        true
            }
        },

        methods: {
            onClose() {
                this.$eventHub.$emit('close-modal')
            },

            onValidate() {
                this.axios.delete(`/api/products/${this.$store.state.single.data.id}`)
                    .then(response => {
                        this.$eventHub.$emit('close-modal')
                        this.$router.push({ name: 'products' })
                    })
                    .catch(error => {
                        console.log(error.response.data || error)
                    })
            }
        }

    }
</script>

<style lang="stylus" scoped>
div {
    padding: 1rem 4rem;
}
</style>



// WEBPACK FOOTER //
// src/views/products/single/Delete.vue